<template>
  <div class="page_bg">
    <div class="coupon_box">
      <!-- top -->
      <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
        <van-icon name="arrow-left" @click="backPath" />
        <div class="top_name">优惠券</div>
        <div class="top_icon" />
      </div>
      <!-- body -->
      <div class="coupon_list flex-c-c-c" style="margin-bottom: 3.4rem;">
        <div class="coupon_tab flex-r-s-c">
          <div :class="actived === 1?'tab_active tab_item':'tab_item'" @click="getCouponList(1,true)">可用券</div>
          <div :class="actived === 2?'tab_active tab_item':'tab_item'" @click="getCouponList(2,true)">已使用</div>
          <div :class="actived === 3?'tab_active tab_item':'tab_item'" @click="getCouponList(3,true)">已失效</div>
        </div>
        <!-- <transition-group name="van-slide-up"> -->
        <template v-if="actived === 1">
          <div v-for="(item1,index1) in copuponList1" :key="index1" style="position: relative;">
            <div v-if="item1.mergeType === 0">
              <van-image width="8.93rem" height="2.29rem" :src="item1.icon" @click="jumpDetail(item1)" />
              <van-checkbox v-if=" showCheck && (item1.couponClass === 1 || item1.couponClass === 0)"
                            v-model="item1.checked" checked-color="#0767ab" class="coupon_check"
                            @click="choosed_conpon(item1)"
              />
            </div>
            <div v-if="item1.mergeType === 1" class="hecheng_coupon flex-r-s-c">
              <div class="pirce" style="color: #ED0D0D;">
                <span style="font-size: 0.37rem;">￥</span>{{ item1.money }}
              </div>
              <div class="msg flex-c-s-s">
                <div style="font-size: 0.37rem;font-weight: 700;color: #333;">商城通用现金券</div>
                <div style="font-size: 0.32rem;color: #333;">满{{ item1.atLeast }}可用</div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="actived === 2">
          <van-image v-for="(item2,index2) in copuponList2" :key="index2" width="8.93rem" height="2.29rem"
                     :src="item2.icon"
          />
        </template>
        <template v-if="actived === 3">
          <div v-for="(item3,index3) in copuponList3" :key="index3" style="position: relative;">
            <div v-if="item3.mergeType === 1" class="hecheng_coupon flex-r-s-c">
              <div class="pirce" style="color: #ED0D0D;">
                <span style="font-size: 0.37rem;">￥</span>{{ item3.money }}
              </div>
              <div class="msg flex-c-s-s">
                <div style="font-size: 0.37rem;font-weight: 700;color: #333;">商城通用现金券</div>
                <div style="font-size: 0.32rem;color: #333;">满{{ item3.atLeast }}可用</div>
              </div>
            </div>
            <van-image v-else width="8.93rem" height="2.29rem" :src="item3.invalidIcon" />
          </div>
        </template>
        <!-- </transition-group> -->
        <van-empty v-if="copuponList1.length === 0 && actived === 1" class="custom-image"
                   image="https://oss.xiaoyi120.com/shop2.0/public/coupon_empty.png" description="没有可用的优惠券呢..."
        />
        <van-empty v-if="copuponList2.length === 0 && actived === 2" class="custom-image"
                   image="https://oss.xiaoyi120.com/shop2.0/public/coupon_empty.png" description="没有已使用的优惠券呢..."
        />
        <van-empty v-if="copuponList3.length === 0 && actived === 3" class="custom-image"
                   image="https://oss.xiaoyi120.com/shop2.0/public/coupon_empty.png" description="没有已失效的优惠券呢..."
        />
      </div>
    </div>
  </div>
</template>

<script>
import './index.scss'
import { user_coupons } from '@/api/user'
export default {
  data() {
    return {
      actived: 1,
      copuponList1: [],
      copuponList2: [],
      copuponList3: [],
      activedIndex: 0,
      actived2Index: 0,
      showCheck: false,
      // isCanAdd: false,
      choose: { num: 0, total: 0 },

      tabIndex: 0,

      statusType: ''
    }
  },
  created() {
    this.getCouponList(1, true)
    // this.isCanAdd = this.$route.query.isCanAdd
  },
  methods: {
    backPath() { window.history.back() },
    getCouponList(index, flag) {
      this.actived = index
      if (flag) {
        this.statusType = ''
      }
      user_coupons({ pageNum: 1, pageSize: 999, status: this.actived }).then(res => {
        if (this.actived === 1) {
          this.activedIndex = res.data.total
          this.copuponList1 = res.data.list
        } else if (this.actived === 2) {
          this.actived2Index = res.data.total
          this.copuponList2 = res.data.list
        } else if (this.actived === 3) { this.copuponList3 = res.data.list }
      })
    },
    choosed_conpon(item) {
      console.log(item)
      if (item.checked) {
        this.choose.num += 1
        this.choose.total += item.money * 1
      } else {
        this.choose.num -= 1
        this.choose.total -= item.money * 1
      }
    },
    changeTab(index) { this.tabIndex = index },
    chooseCoupon(item, index) {
      this.getCouponList(this.actived)
    },
    changeStatus(status) {
      this.statusType = status
      this.getCouponList(this.actived)
    },
    jumpDetail(item) {
      console.log(item)
      if (item.rangeType === 2) {
        this.$router.push({ path: '/product/couponProList', query: { couponTypeId: item.couponTypeId } })
      }
    }
  }
}
</script>

<style scoped>
.coupon_check {
  position: absolute;
  top: 1rem;
  right: 0.78rem;
}
.add_btn {
  position: fixed;
  bottom: 0rem;
  width: 100%;
  height: 2rem;
  background: #fff;
}
.choose_item {
  position: fixed;
  bottom: 0rem;
  width: 100%;
  height: 3.3rem;
  background: #fff;
}
.item_tips {
  height: 1.6rem;
  background: #fdf4f5;
  font-size: 0.37rem;
  padding-top: 0.27rem;
  padding-left: 0.67rem;
}
/* .tab_item_xxx {
  width: 2rem;
  height: 2rem;
  background: rgb(102, 165, 204);
  color: #333;
  line-height: 2rem;
}
.tab_item_actived{
  height: 2.5rem;
} */
</style>

<style>
.custom-image {
  background: #fff;
  padding-top: 40%;
}
.custom-image .van-empty__image {
  width: 5.14rem;
  height: 3.43rem;
}
</style>
